/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';
import {
  Button,
  Dimmer,
  Grid,
  Header,
  Icon,
  Loader,
  Segment,
  Divider,
  Popup,
  Menu,
} from 'semantic-ui-react';
import { useTranslation, withTranslation } from 'react-i18next';
import { SortableElement, arrayMove } from 'react-sortable-hoc';
import { UnitPackageFeeEdit } from '.';
import { SortableContainer, SortableDragHandle } from '../Sortable';
import AppForm from '../AppForm';
import CurrencySymbol from '../CurrencySymbol';
import EditableBox from '../EditableBox';
import LoanAmount from '../LoanAmount';
import { fetchM } from '../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';
import DeleteConfirm from '../../containers/modals/DeleteConfirm';
import { PROJECT_UNIT_PACKAGE_FEE_DEFAULT } from '../../structs/additional_fee';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

export const ProjectUnitPackageFeeView = ({
  unitPackageFees,
  projectCurrencies = [],
  isPreviewing,
  calculateFeePackage,
}) => {
  const items = [];
  const { t } = useTranslation(TRANSLATION_FILES.screens);

  unitPackageFees.sort((a, b) => a.orderPriority - b.orderPriority).forEach((d) => {
    let formulas = [];

    const pupp = calculateFeePackage.find(data => data.id === d.id);
    if (calculateFeePackage && pupp != null) {
      if (pupp.projectFeePackage.formulas) {
        formulas = [...pupp.projectFeePackage.formulas];
      }
    }

    const newItem = {
      isSPAValue: false,
      projectFeePackageID: d.projectFeePackageID,
      listPrice: d.listPrice,
      spaPrice: d.spaPrice,
      nettPrice: d.nettPrice,
      totalPrice: d.totalPrice,
      formulas,
    };

    if (d.projectFeePackage) {
      let iDesc = d.projectFeePackage.description;
      if (iDesc.includes('\n')) {
        iDesc = iDesc.split('\n').map((desc, idx) => <span key={idx}>{desc}<br /></span>);
      }
      newItem.projectFeePackage = {
        name: d.projectFeePackage.name,
        description: iDesc,
      };
    }
    items.push(newItem);
  });
  const renderApplyToBookingRemarks = (title, applyToBooking) => (
    <span>
      {title}
      <span className="packagePricingApplyToBookingFlag" style={{ color: applyToBooking ? 'green' : 'red' }}>
        Formula item will {!applyToBooking && 'not'} be applied onto the initial booking
      </span>
    </span>
  );
  if (items.length <= 0) {
    return (
      <Grid className="projectUnitPackagePricingView projectUnitPreview" textAlign="center">
        {t('No Additional Fees added')}.
      </Grid>
    );
  }
  return (
    <Grid className="projectUnitPackagePricingView projectUnitPreview" columns={2}>
      {
        isPreviewing ?
          items.map((data, idx) => {
            const formulas = data.formulas && data.formulas.length > 0 ? data.formulas : [];

            return (
              <Grid container key={idx}>
                <Grid.Row columns={16}>
                  <Grid.Column width={8} textAlign="left">
                    <h3>
                      {data.projectFeePackage && data.projectFeePackage.name ? data.projectFeePackage.name : ''}
                    </h3>
                    <small>
                      {data.projectFeePackage && data.projectFeePackage.description ? data.projectFeePackage.description : ''}
                    </small>
                  </Grid.Column>
                  <Grid.Column width={8} textAlign="right">
                    <h3>
                      <LoanAmount
                        projectCurrencies={projectCurrencies}
                        format="0,000,000.00"
                        amount={data.totalPrice}
                        prefix={<CurrencySymbol />}
                      />
                    </h3>
                  </Grid.Column>
                </Grid.Row>
                {
                  formulas.map((formula, key) => (
                    <Grid.Row columns={16} key={key}>
                      <Grid.Column textAlign="left" width={11}>
                        <h5>
                          {formula && formula.name ? renderApplyToBookingRemarks(formula.name, formula.applyToBooking) : ''}
                        </h5>
                        <small>
                          {formula && formula.description ? formula.description : ''}
                        </small>
                      </Grid.Column>
                      <Grid.Column textAlign="right" width={5}>
                        <div>
                          <small>
                            <Icon color="green" size="small" name="plus" />
                          </small>
                          <span
                            className="div_inline_block text_add"
                          >
                            <LoanAmount
                              projectCurrencies={projectCurrencies}
                              format="0,000,000.00"
                              amount={formula.valueChange}
                              prefix={<CurrencySymbol />}
                              precise={false}
                            />
                          </span>
                        </div>
                      </Grid.Column>
                    </Grid.Row>
                  ))
                }
                <Divider />
              </Grid>
            );
          })
        :
        // when preview button is not clicked only show packages with pricing
        items.map((data, idx) => (
          <Grid container key={idx} className="singlePPItemRow">
            <Grid.Row>
              <Grid.Column width={8} verticalAlign="middle" textAlign="right">
                <Header as="h4" className={data.isSPAValue ? 'spaValue' : ''}>
                  {data.projectFeePackage && data.projectFeePackage.name ? data.projectFeePackage.name : ''}
                  <Header.Subheader>
                    {data.projectFeePackage && data.projectFeePackage.description ? data.projectFeePackage.description : ''}
                  </Header.Subheader>
                </Header>
              </Grid.Column>
              <Grid.Column width={8} verticalAlign="middle">
                <h3 className={data.isSPAValue ? 'spaValue' : ''}>
                  <LoanAmount
                    projectCurrencies={projectCurrencies}
                    format="0,000,000.00"
                    amount={data.totalPrice}
                    prefix={<CurrencySymbol />}
                    precise={false}
                  />
                </h3>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        ))
      }
    </Grid>
  );
};
ProjectUnitPackageFeeView.propTypes = {
  projectCurrencies: PropTypes.oneOfType([PropTypes.array]),
  unitPackageFees: PropTypes.oneOfType([PropTypes.array]).isRequired,
  isPreviewing: PropTypes.bool,
  calculateFeePackage: PropTypes.oneOfType([PropTypes.array]).isRequired,
};

const SortableItem = SortableElement(props => (
  <div className={`sortablehoc_item ${props.itemClass ? props.itemClass : ''}`}>
    <Segment className="package_pricing_unit">
      <Grid>
        <Grid.Row verticalAlign="middle">
          <Grid.Column mobile={2} tablet={2} computer={1}>
            <SortableDragHandle {...props} />
          </Grid.Column>
          <Grid.Column mobile={11} tablet={12} computer={12}>
            <UnitPackageFeeEdit
              {...props}
              data={props.value}
              feePackages={props.feePackages}
              onChange={props.onChange}
              refValidation={props.refValidation}
              refForm={props.refForm}
            />
          </Grid.Column>
          <Grid.Column mobile={3} tablet={2} computer={3} textAlign="right" style={{ paddingLeft: '0' }}>
            <Popup
              trigger={
                <Button
                  basic
                  style={{ padding: '0.5em' }}
                >
                  <Icon
                    name="ellipsis horizontal"
                    rotated="clockwise"
                    style={{ margin: '0 auto' }}
                  />
                </Button>
              }
              size="small"
              position="bottom right"
              flowing
              hoverable
              wide
              className="popupUnitInfo"
            >
              <Grid>
                <Grid.Row>
                  <Grid.Column>
                    <Menu fluid vertical className="unitInfoPPpopupButton">
                      <Menu.Item className="deleteUnitPackageFee">
                        <Button
                          size="small"
                          basic
                          onClick={() => props.onDelete(props.value)}
                        >
                          <Icon name="trash" color="red" />
                          <span>{props.t('Delete', { ns: TRANSLATION_FILES.translation })}</span>
                        </Button>
                      </Menu.Item>
                    </Menu>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Popup>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  </div>
));

class ProjectUnitPackageFee extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    data: PropTypes.oneOfType([PropTypes.array]).isRequired,
    handleCheckChanges: PropTypes.func,
    handleResetCheck: PropTypes.func,
    hasEditAccess: PropTypes.bool,
    hasPreviewPriceAccess: PropTypes.bool,
    loading: PropTypes.bool,
    newFetch: PropTypes.func,
    feePackages: PropTypes.oneOfType([PropTypes.array]).isRequired,
    projectCurrencies: PropTypes.oneOfType([PropTypes.array]),
    projectID: PropTypes.string,
    unitID: PropTypes.string,
    spaValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
    token: PropTypes.string,
    calculateFeePackage: PropTypes.oneOfType([PropTypes.array]).isRequired,
    t: PropTypes.func,
  }
  static getPropsToState = (props) => {
    const data = props.data || [];
    const loading = props.loading;
    const feePackages = props.feePackages || [];
    const calculateFeePackage = props.calculateFeePackage || [];
    const token = props.token || '';

    return {
      data,
      oriData: clone(data),
      loading,
      feePackages,
      calculateFeePackage,
      token,
    };
  }
  constructor(props) {
    super(props);
    const state = ProjectUnitPackageFee.getPropsToState(props);
    this.state = {
      ...state,
      editing: false,
      showDeleteConfirm: false,
      deleteIDX: null,
      deleteData: Object.assign({}, PROJECT_UNIT_PACKAGE_FEE_DEFAULT),
      showPreview: false,
    };
    this.editRef = [];
    this.formRef = {};
  }
  componentWillReceiveProps(nextProps) {
    const state = ProjectUnitPackageFee.getPropsToState(nextProps);
    if (JSON.stringify(this.state.data) !== JSON.stringify(state.data)) {
      this.setState({ ...state });
    }
    if (JSON.stringify(this.state.calculateFeePackage) !== JSON.stringify(state.calculateFeePackage)) {
      this.setState({
        calculateFeePackage: state.calculateFeePackage,
      });
    }
  }
  onSortEnd = ({ oldIndex, newIndex }) => {
    const data = this.sortDataByIndex(arrayMove(this.state.data, oldIndex, newIndex));
    this.setState({ data }, () => {
      if (this.props.handleCheckChanges) this.props.handleCheckChanges();
    });
  };
  setLoading = (loading = false) => new Promise((res) => {
    this.setState({ loading }, () => {
      res(loading);
    });
  })
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  getFeePackages = () => {
    const { data } = this.state;
    const feePackages = this.state.feePackages.filter(p => !data.find(d => d.id !== '' && d.projectFeePackageID === p.id)).sort((a, b) => a.orderPriority - b.orderPriority);
    const options = [];
    feePackages.forEach((p) => {
      const newItem = {
        text: p.name,
        value: p.id,
      };
      // disabled the option once selected
      const selectedItem = data.find(d => d.projectFeePackageID === p.id);
      if (selectedItem) newItem.disabled = true;
      options.push(newItem);
    });
    return options;
  }
  setRefValidation = (ref, idx) => {
    if (ref && ref.props && ref.props.name) {
      if (!this.editRef[idx]) this.editRef[idx] = {};
      this.editRef[idx][ref.props.name] = ref;
    }
  }
  setRefForm = (ref) => {
    this.formRef = ref;
  }
  sortDataByIndex = (newData) => {
    const data = newData;
    data.forEach((d, index) => {
      data[index].orderPriority = index + 1;
    });
    return data;
  }
  async deleteUnitPackageFee(id, callBack) {
    await this.setLoading(true);
    const { store } = this.context;
    const { projectID, unitID } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${projectID}/units/${unitID}/fee_packages/${id}/`, {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
      }));
    } catch (e) {
      await this.setLoading(false);
      if (e.res && e.res.status >= 400 && e.res.status < 500) {
        const message = await e.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      await store.dispatch(flashSuccessMessage({ header: 'Delete Success', message: 'Unit additional fee package successfully deleted' }));
    }
    await this.setLoading(false);
    if (callBack) callBack();
  }
  async updateUnitPackageFees() {
    await this.setLoading(true);
    const { store } = this.context;
    const { projectID, unitID } = this.props;
    const data = this.state.data.filter((d) => {
      const newD = d;
      newD.totalPrice = parseFloat(d.totalPrice);
      return newD;
    });
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${projectID}/units/${unitID}/fee_packages/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
        body: JSON.stringify(data),
      }));
    } catch (e) {
      await this.setLoading(false);
      if (e.res && e.res.status >= 400 && e.res.status < 500) {
        const message = await e.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      if (this.props.newFetch) await this.props.newFetch();
      await store.dispatch(flashSuccessMessage({ header: 'Update Success', message: 'Unit additional fee package successfully updated' }));
      if (this.props.handleResetCheck) this.props.handleResetCheck();
    }
    await this.setLoading(false);
  }
  asyncForEach = async (array, callback) => {
    for (let index = 0; index < array.length; index += 1) {
      await callback(array[index], index, array);
    }
  }
  handleEditing = () => {
    this.setState({ editing: true });
  }
  handleResetEditing = () => {
    if (this.props.handleResetCheck) this.props.handleResetCheck();
    this.setState({
      editing: false,
    }, async () => {
      if (JSON.stringify(this.state.data) !== JSON.stringify(this.props.data)) {
        if (this.props.newFetch) await this.props.newFetch();
      }
    });
  }
  handleUpdate = async () => {
    if (JSON.stringify(this.state.data) === JSON.stringify(this.state.oriData)) {
      await this.setComponentState({ editing: false });
      return;
    }
    const { store } = this.context;
    const { data } = this.state;
    let hasError = false;
    await this.asyncForEach(data, async (d, idx) => {
      if (this.editRef[idx] && !hasError) {
        const validations = await AppForm.validate(this.editRef[idx], data[idx]);
        const errMessages = validations.filter(v => !v.isValid);
        if (errMessages.length > 0) {
          hasError = true;
          await store.dispatch(flashErrorMessage({ header: 'Please fix form errors', list: errMessages.map(l => l.message) }));
        }
      }
    });
    if (!hasError) {
      await this.updateUnitPackageFees();
      await this.setComponentState({ editing: false });
    }
  }
  handleOnChange = (d, idx) => {
    const { data } = this.state;
    const newData = [];
    data.forEach((item, i) => {
      if (i === idx) {
        newData.push(d);
      } else {
        newData.push(item);
      }
    });
    this.setState({ data: newData }, () => {
      if (this.editRef[idx]) AppForm.validate(this.editRef[idx], newData[idx]);
      if (this.props.handleCheckChanges) this.props.handleCheckChanges();
    });
  }
  handleDelete = (d, idx) => {
    this.setState({
      showDeleteConfirm: true,
      deleteIDX: idx,
      deleteData: d,
    });
  }
  handleCancelDelete = (e) => {
    e.preventDefault();
    this.setState({
      showDeleteConfirm: false,
      deleteIDX: null,
      deleteData: Object.assign({}, PROJECT_UNIT_PACKAGE_FEE_DEFAULT),
    });
  }
  handleConfirmDelete = async (e) => {
    e.preventDefault();
    const { deleteData } = this.state;
    if (deleteData.id !== '') {
      await this.deleteUnitPackageFee(deleteData.id, () => {
        this.confirmDelete();
      });
    } else {
      this.confirmDelete();
    }
  }
  confirmDelete = () => {
    const { data, deleteIDX } = this.state;
    const newData = [];
    data.forEach((item, i) => {
      if (i !== deleteIDX) {
        newData.push(item);
      }
    });
    this.setState({
      data: this.sortDataByIndex(newData),
      deleteData: Object.assign({}, PROJECT_UNIT_PACKAGE_FEE_DEFAULT),
      deleteIDX: null,
      showDeleteConfirm: false,
    }, () => {
      if (this.props.handleCheckChanges) this.props.handleCheckChanges();
    });
  }
  handleAdd = (e) => {
    e.preventDefault();
    const { data } = this.state;
    const { projectID, unitID } = this.props;
    const newItem = clone(Object.assign({}, PROJECT_UNIT_PACKAGE_FEE_DEFAULT, {
      orderPriority: data.length + 1,
      projectID,
      projectUnitID: unitID,
    }));
    data.push(newItem);
    this.setState({ data }, () => {
      if (this.props.handleCheckChanges) this.props.handleCheckChanges();
    });
  }
  handleTogglePreview = (e) => {
    e.preventDefault();
    this.setState(prevState => ({
      showPreview: !prevState.showPreview,
    }));
  }
  render() {
    const {
      data,
      loading,
      showDeleteConfirm,
      showPreview,
      calculateFeePackage,
    } = this.state;
    const {
      projectCurrencies,
      hasEditAccess,
      hasPreviewPriceAccess,
      t,
    } = this.props;
    return (
      <div>
        <DeleteConfirm
          content={t('Are you sure you want to delete this unit additional fee package?')}
          onClose={this.handleCancelDelete}
          onConfirm={this.handleConfirmDelete}
          open={showDeleteConfirm}
        />
        <EditableBox
          editable={hasEditAccess}
          isEditing={this.state.editing}
          loading={loading}
          onCancel={this.handleResetEditing}
          onClick={this.handleUpdate}
          onEdit={this.handleEditing}
          showPreview={showPreview}
          content={({ isEditing }) => (
            <div>
              <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
                <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
              </Dimmer>
              {
                hasPreviewPriceAccess && data && data.length > 0 ?
                  <Button
                    as="button"
                    attached="top"
                    style={{
                      background: showPreview ? '#eae8e8' : 'none',
                      top: hasEditAccess ? '-2.5em' : '0',
                      borderRadius: '0.2em',
                      paddingRight: '1.5em',
                      display: isEditing ? 'none' : 'inline-block',
                      marginBottom: hasEditAccess ? '0' : '2em',
                    }}
                    content={t(showPreview ? 'Close' : 'Preview Fee Breakdown', { ns: showPreview && TRANSLATION_FILES.translation })}
                    icon={showPreview ? 'close' : 'eye'}
                    size="tiny"
                    onClick={this.handleTogglePreview}
                  />
              : null
              }
              {
                isEditing ?
                  <Grid>
                    <Grid.Row>
                      <Grid.Column width={16}>
                        {data.length > 0 ? (
                          <SortableContainer
                            isSortMode
                            iconColor="blue"
                            helperClass="sorting"
                            data={data}
                            lockAxis="y"
                            lockToContainerEdges
                            onSortEnd={this.onSortEnd}
                            useDragHandle
                            item={props => (
                              <SortableItem
                                {...props}
                                onChange={d => this.handleOnChange(d, props.idx)}
                                onDelete={d => this.handleDelete(d, props.idx)}
                                refForm={this.setRefForm}
                                refValidation={ref => this.setRefValidation(ref, props.idx)}
                                feePackages={this.getFeePackages}
                                t={t}
                              />
                            )}
                          />
                        ) : (
                          <Segment className="segment_unit_pricing_package_not_found" textAlign="center">{t('No unit additional fee package found')}</Segment>
                        )}
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row textAlign="center">
                      <Grid.Column width={16}>
                        <Button
                          basic
                          onClick={this.handleAdd}
                        >
                          <Icon name="add circle" color="green" /> {t('Add additional fee package')}
                        </Button>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                  :
                  <ProjectUnitPackageFeeView
                    unitPackageFees={data}
                    projectCurrencies={projectCurrencies}
                    isPreviewing={showPreview}
                    calculateFeePackage={calculateFeePackage}
                  />
              }
            </div>
          )}
        />
      </div>
    );
  }
}

export default withTranslation(namespaces)(ProjectUnitPackageFee);



// WEBPACK FOOTER //
// ./src/components/ProjectUnitPackageFee/ProjectUnitPackageFee.jsx